module.exports = __webpack_public_path__ + "img/monitor-swiper-1.556be7b2.png";